import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_EXAM_LEVEL_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_EXAM_LEVEL_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamLevelObject {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetCoordinatorAppealExamLevel = ({ onSuccess, onError }: Input = {}) => {
  const getCoordinatorAppealExamLevel = async () => {
    const res = await axiosClient.get<ExamLevelObject[]>(GET_COORDINATOR_APPEAL_EXAM_LEVEL_URL);
    return res.data;
  };

  return useCustomQuery(
    GET_COORDINATOR_APPEAL_EXAM_LEVEL_QUERY_KEY,
    getCoordinatorAppealExamLevel,
    {
      onSuccess,
      onError,
    }
  );
};
